// @ts-nocheck
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Bell-card after a trade commits — fired for BOTH participants. Tapping it
 * takes the user to My Decorations so they can see / equip the newly
 * acquired items.
 */
export default class TradeCompletedNotification extends Notification {
  icon() {
    return 'fas fa-exchange-alt';
  }
  href() {
    try {
      return app.route('pointSystem.decorations');
    } catch (_unused) {
      return '/';
    }
  }
  content() {
    var _this$attrs$notificat, _this$attrs$notificat2, _fromUser$displayName;
    const fromUser = (_this$attrs$notificat = (_this$attrs$notificat2 = this.attrs.notification).fromUser) == null ? void 0 : _this$attrs$notificat.call(_this$attrs$notificat2);
    const name = (fromUser == null || (_fromUser$displayName = fromUser.displayName) == null ? void 0 : _fromUser$displayName.call(fromUser)) || app.translator.trans('ramon-point-system.forum.notifications.admin_fallback');
    return app.translator.trans('ramon-point-system.forum.notifications.trade_completed', {
      name
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/TradeCompletedNotification', TradeCompletedNotification);